import React, { useEffect, useState } from "react";
import "../../_css/Header.css";
import { useNavigate } from "react-router-dom";
import { getUserProfile } from "../../requests";
import { useSelector, useDispatch } from "react-redux";
import { updateUserSessionData } from "../../utils/helper";

const Header = ({ name = [], params = {} }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [heading, setHeading] = useState([]);
  const [profile, setProfile] = useState("/img/defaultProfile.png");

  const { remainingUploads } = useSelector((state) => state.plan);

  const handleClick = (e) => {
    const ans = e.target.textContent.trim();

    if (ans == "Upload Answer Sheets >") {
      navigate("/");
      return;
    }
    if (ans == "Student list >") {
      navigate(-1);
      return;
    }
    if (ans == "Student Report >") {
      navigate("/student-reports");
      return;
    }

    if (ans == "Report History >") {
      navigate("/report-history");
      return;
    }

    if (ans == "Content Management >") {
      navigate("/cms");
      return;
    }
    if (ans == "School Management >") {
      navigate("/school-management");
      return;
    }
    if (ans == "AI Feedback >") {
      navigate("/ai-feedback");
      return;
    }
    if (ans == "AI Feedback Students >") {
      navigate("/ai-feedback/students");
      return;
    }
    if (ans == "Teachers >") {
      navigate(-1);
      return;
    }
    if (ans == "Student Reports >") {
      navigate("/student-reports");
      return;
    }
    if (ans == "Students >") {
      if(params.grade && params.exam){
        navigate(`/student-reports/students?grade=${params.grade}&exam=${params.exam}`);
        return;
      }
      navigate(-1);
      return;
    }
  };

  const getUser = async () => {
    try {
      const res = await getUserProfile();
      setProfile(res?.data?.user?.profile);

      // Update sessionStorage and Redux using centralized function
      updateUserSessionData(res?.data, dispatch);
    } catch (error) {
      console.log(error);
      setProfile("/img/defaultProfile.png");
    }
  };

  useEffect(() => {
    if (name.length > 0) {
      const result = name.map((e, i) => (i != name.length - 1 ? e + " >" : e));

      setHeading(result);

      getUser();
    }
  }, []);

  return (
    <div className="header-container">
      <div className="header-left" style={{ display: "flex", gap: "10px" }}>
        {heading.length > 0 &&
          heading.slice(0, heading.length - 1).map((e, i) => (
            <div
              className="pe-cursor"
              onClick={handleClick}
              key={i}
              style={{ color: "#9CA3AF", fontWeight: "500" }}
            >
              {e}
            </div>
          ))}

        {/* {<div style={{color:'#9CA3AF' ,fontWeight:'500'}}>{heading.slice(0,heading.length - 1)}</div>} */}
        {
          <div className="pe-cursor" onClick={handleClick}>
            {" "}
            {heading.length > 0 && heading[heading.length - 1]}
          </div>
        }
      </div>
      <div className="header-right">
        {localStorage.getItem("ACCOUNT_STATUS") == 0 && (
          <div className="header-plan-info">
            <div
              className="header-plan-name"
              style={{
                backgroundColor: (() => {
                  const planInfo = JSON.parse(
                    sessionStorage.getItem("planInfo")
                  );
                  if (!planInfo) return "#EF4444"; // Default blue
                  const planName = planInfo?.plan_name?.toLowerCase() || "";
                  if (planName.includes("trial")) return "#FCD34D"; // Yellow
                  if (planName.includes("expired")) return "#EF4444"; // Red
                  return "#03A3E3"; // Blue for all other
                })(),
              }}
            >
              {JSON.parse(sessionStorage.getItem("planInfo"))?.plan_name ||
                "N/A"}
            </div>
            <p className="header-remaining-uploads">
              Remaining Pages: {remainingUploads}
            </p>
          </div>
        )}
        <div className="header-profile-image">
          <img style={{ objectFit: "cover" }} src={profile} alt="Profile" />
        </div>
      </div>
    </div>
  );
};

export default Header;
